module.exports = __webpack_public_path__ + "img/login.45eae274.png";